<template>
  <div class="merchant-account-projects">
    <table class="table table-striped table-hover table-condensed no-margin">
      <thead>
        <tr>
          <th>Id</th>
          <th>Property</th>
          <th>Remove</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="project in associatedProjects" v-bind:value="project.id">
          <td>{{ project.id }}</td>
          <td>{{ project.name }}</td>
          <td>
            <button
              type="button"
              class="btn btn-warning"
              @click="removeProject(project.id)"
              :disabled="loading"
            >
              Remove
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <hr />
    <div class="row">
      <div class="form-group has-feedback col-sm-6">
        <select v-model="addProjectSelected" class="form-control">
          <option v-for="project in possibleProjects" v-bind:value="project.id">
            {{ project.name }}
          </option>
        </select>
      </div>
      <div class="form-group has-feedback col-sm-6">
        <button
          type="button"
          class="btn btn-success"
          @click="addProject()"
          :disabled="loading"
        >
          Add Project
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    merchant_account_id: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      addProjectSelected: null,
      loading: true,
      associatedProjects: [],
      possibleProjects: [],
    };
  },

  mounted() {
    this.loadAssociatedProjects()
      .catch(this.$root.handleErrors)
      .finally(() => {
        this.loading = false;
      });
    this.loadProjectOptions()
      .catch(this.$root.handleErrors)
      .finally(() => {
        this.loading = false;
      });
  },

  computed: {},

  methods: {
    removeProject: function(projectId) {
      this.loading = true;
      var url =
        "/api/merchantAccounts/" +
        this.merchant_account_id +
        "/removeProject/" +
        projectId;
      axios
        .get(url)
        .then(() => {
          this.loadAssociatedProjects();
          this.loadProjectOptions();
        })
        .catch(this.$root.handleErrors)
        .finally(() => {
          this.loading = false;
        });
    },
    addProject: function() {
      this.loading = true;
      if (this.addProjectSelected !== null) {
        var url =
          "/api/merchantAccounts/" +
          this.merchant_account_id +
          "/addProject/" +
          this.addProjectSelected;
        axios
          .get(url)
          .then(() => {
            this.loadAssociatedProjects();
            this.loadProjectOptions();
          })
          .catch(this.$root.handleErrors)
          .finally(() => {
            this.loading = false;
          });
      }
    },
    loadAssociatedProjects() {
      var url =
        "/api/merchantAccounts/projects?merchantAccountId=" +
        this.merchant_account_id;

      return axios
        .get(url)
        .then((response) => {
          this.associatedProjects = response.data.Projects.map((project) => {
            project.created_at = new moment.utc(project.created_at);

            return project;
          });
        })
        .catch(this.$root.handleErrors);
    },
    loadProjectOptions() {
      var url =
        "/api/merchantAccounts/projectsOptions?merchantAccountId=" +
        this.merchant_account_id;
      this.addProjectSelected = null;

      return axios
        .get(url)
        .then((response) => {
          this.possibleProjects = response.data.Projects.map((project) => {
            return project;
          });
        })
        .catch(this.$root.handleErrors);
    },
  },
};
</script>
